module.exports = "pegasus/assets/themelp1/tickets/102.png";